import { GET_ALL_DC_LIST, SEARCHED_DC_LIST } from './actionTypes';

export const getAllDCListInit = () => ({
    type: GET_ALL_DC_LIST.INIT
})

export const getAllDCListSuccess = DCList => ({
    type: GET_ALL_DC_LIST.SUCCESS,
    payload: DCList
})

export const getAllDCListFailure = errorMessage => ({
    type: GET_ALL_DC_LIST.ERROR,
    payload: errorMessage
})

export const setSelectedDCList = dcList => ({
    type: SEARCHED_DC_LIST.SET,
    payload: dcList
})